import { inject, Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import {
  FormDashboardDialogComponent,
  FormDashboardDialogData,
} from '@shared/components/molecules/ui-molecule-dialog-form-dashboard/ui-molecule-dialog-form-dashboard.component';

@Injectable({ providedIn: 'root' })
export class DialogFormDashboardService {
  private readonly dialog = inject(MatDialog);

  /** Abre el diálogo de dashboard de un form con la configuración estándar. */
  open(data: FormDashboardDialogData): MatDialogRef<FormDashboardDialogComponent> {
    return this.dialog.open<FormDashboardDialogComponent, FormDashboardDialogData>(
      FormDashboardDialogComponent,
      {
        data,
        panelClass: ['dialog-lg', 'dialog-safe-area', 'dialog-flex'],
        width: '80vw',
        maxWidth: '1200px',
        height: '90vh',
        disableClose: false,
        autoFocus: false,
      },
    );
  }
}
